var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.008,
    height: 65.785,
    viewBox: "0 0 79.008 65.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.5 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.414,70.262,21.27,28H3.5Z",
    transform: "translate(0 6.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.216,31.405,42.283,12H31.832L18.9,31.405Z",
    transform: "translate(5.946 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.925,28H18.5L37.212,71.607Z",
    transform: "translate(5.791 6.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.734,28,34.59,70.262,70.5,28Z",
    transform: "translate(12.004 6.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,31.405,34.436,12H18.995a1.386,1.386,0,0,0-1.1.541L3.54,31.405Zm42.969,0H82.492L68.077,12.541a1.386,1.386,0,0,0-1.1-.541H51.541Z",
    transform: "translate(0.015 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits);
export default __webpack_public_path__ + "static/media/benefits.c9209712d2ab5644ebfffd3bcb48ceec.svg";
export { ForwardRef as ReactComponent };